import React, { useMemo, memo } from 'react';
import { useSelector } from 'react-redux';
import { GEOCOMM } from '@rsos/reduxDataStore/src/features/gisSearch/constants';
import { CALLS } from '@rsos/search/src/constants';
import {
  ResultsContainer as StyledResultsContainer,
  OverflowWrapper,
} from './ConnectedUniversalSearch.styles';
import { ErrorWrapper } from './ErrorWrapper';
import StyledCall from './styledDropdown/StyledCall';
import StyledSuggestedAddress from './styledDropdown/StyledSuggestedAddress';

const SEARCH_INPUT_PADDING = 20;
const RESULT_CONTAINER_MAX_HEIGHT = '224px';

export const ResultsContainer = memo(
  ({
    displayResultContainer,
    hasError,
    isValidW3W,
    mouseCursor,
    isInternational,
    formatPhoneWithDashes,
    handleSearchResult,
    isPremiumUser,
    hasGisSearchAccess,
    resultContainerRef,
    gisSearchResults,
    filteredCallResults,

    handleSelectedAddress = () => {},
  }) => {
    const isGeocomm = useSelector(state =>
      state.gisServices?.geocodeService?.gis_service_url?.includes(GEOCOMM),
    );
    const maxWidth =
      document.documentElement.clientWidth - SEARCH_INPUT_PADDING; // ugly solution for making fixed width elements dynamic while resizing the screen

    const combinedResults = useMemo(() => {
      return [...filteredCallResults, ...gisSearchResults];
    }, [filteredCallResults, gisSearchResults]);

    const isVisible = useMemo(() => {
      return displayResultContainer && (hasError || combinedResults.length > 0);
    }, [combinedResults.length, displayResultContainer, hasError]);
    return isVisible ? (
      <StyledResultsContainer maxWidth={maxWidth} hasError={hasError}>
        {hasError && combinedResults.length === 0 ? (
          <ErrorWrapper isValidW3W={isValidW3W} />
        ) : (
          <OverflowWrapper
            maxHeight={RESULT_CONTAINER_MAX_HEIGHT}
            ref={resultContainerRef}
          >
            {combinedResults.reduce((accumulator, result, idx) => {
              if (
                result.data?._datasetName === CALLS &&
                (result.data?.core?.locations?.length ||
                  result.data?.core?.secondaryLocations?.length)
              ) {
                const styledData = [
                  ...accumulator,
                  <StyledCall
                    key={idx}
                    call={result.data}
                    index={idx}
                    mouseCursor={mouseCursor}
                    isPremiumUser={isPremiumUser}
                    formatPhoneWithDashes={formatPhoneWithDashes}
                    handleSearchResult={handleSearchResult}
                    isInternational={isInternational}
                    handleSelectedAddress={handleSelectedAddress}
                    maxWidth={maxWidth}
                  />,
                ];
                return styledData;
              } else if (result.address && hasGisSearchAccess) {
                const styledData = [
                  ...accumulator,
                  <StyledSuggestedAddress
                    key={idx}
                    address={result}
                    index={idx}
                    mouseCursor={mouseCursor}
                    handleSelectedAddress={handleSelectedAddress}
                    isGeocomm={isGeocomm}
                  />,
                ];
                return styledData;
              } else {
                return accumulator;
              }
            }, [])}
          </OverflowWrapper>
        )}
      </StyledResultsContainer>
    ) : null;
  },
);
